import { Route, Routes } from 'react-router-dom';
import { BrandExtractionFunnel } from '../funnels/brand-extraction-funnel/brand-extraction-funnel';

export const BrandsRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<BrandExtractionFunnel />} />
    </Routes>
  );
};
